<template>
    <div id="devdash-login" class="apply-bootstrap">
        <div class="container">
            <div class="row">
                <div id="devdash-login-form" class="col-4">
                    <login-form c-id="loginForm" prop-instance="dev" prop-user-type="user" prop-message-box=""></login-form>
                    <div v-if="showLinkToAnotherInstance">
                        <p>To access Devdash using {{isProd ? 'QA' : 'production'}} components, datasets, and layouts, click here: <a :href="isProd ? urlOrigin : urlOrigin + '/?isprod'">{{isProd ? 'QA' : 'Production'}} DevDash</a></p>
                    </div>
                    <div v-if="showLinkToSwitchBetweenInstanceAndLocal">
                        <p>Switch to: <a href="javascript:void(0)" @click="switchBetweenInstanceAndLocal">{{devDashInstanceDetails.isLocalhost ? (isProd ? 'Production' : 'QA') : 'Localhost'}} DevDash</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import "@common/syncfusionCss";
import { router } from "@common/router/router";
import { configStore } from "@common/configStore";

const devDashLoginComponent = {
    data() {
        return {
            urlOrigin: false,
            showLinkToAnotherInstance: false,
            showLinkToSwitchBetweenInstanceAndLocal: false,
            devDashInstanceDetails: {}
        };
    },
    computed: {
        isProd() {
            return this.devDashInstanceDetails?.isProd || false;
        }
    },
    components: {
        loginForm: defineAsyncComponent(() => import('@common/loginForm/loginForm.vue'))
    },
    methods: {
        processAction: async function (act) {
            switch (act) {
                case 'login':
                    router.replace({ path: '/' });
                    break;
            }
        },
        switchBetweenInstanceAndLocal: () => {
            actionStore.switchBetweenInstanceAndLocal();
        }
    },
    async mounted() {
        this.devDashInstanceDetails = await configStore.getCurrentInstanceDetails(true);
        this.showLinkToAnotherInstance = typeof FROM_LOCALHOST !== 'undefined' ? FROM_LOCALHOST : false;
        this.urlOrigin = window.location.origin;
        library.setSessionStorage('devDashEnv', this.devDashInstanceDetails.isProd ? 'prod' : 'dev');

        this.showLinkToSwitchBetweenInstanceAndLocal = this.devDashInstanceDetails.isLocalhost || this.devDashInstanceDetails.quicklink;
    }
};

export default devDashLoginComponent;
</script>

<style lang="css">
#devdash-login h1, #devdash-login .h1 {
    font-size: 32px;
    font-weight: 400;
}

#devdash-login label {
    margin-bottom: 0;
}

#devdash-login button, #devdash-login input, #devdash-login select, #devdash-login textarea {
    background-color: transparent;
    border-style: none;
}

#devdash-login {
    padding-top: 200px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;
}
#devdash-login-form {
    margin: 0 auto;
}
</style>
